export function buildHuddleLink(chatId: string, origin = window.location.origin): string {
  const url = new URL('/messages', origin);
  url.searchParams.set('huddle', chatId);
  return url.toString();
}

export function readHuddleLink(search: string): string | null {
  const chatId = new URLSearchParams(search).get('huddle');
  return chatId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(chatId)
    ? chatId.toLowerCase()
    : null;
}

const WINDOW_PARAM = 'window';

/** The address a huddle window opens at: the shared huddle link, marked as the
 *  huddle's own window so it closes itself when the huddle ends. */
export function buildHuddleWindowLink(chatId: string, origin = window.location.origin): string {
  const url = new URL(buildHuddleLink(chatId, origin));
  url.searchParams.set(WINDOW_PARAM, 'huddle');
  return url.toString();
}

const WINDOW_NAME_PREFIX = 'quantis-huddle-';

/** True inside a window opened for a huddle. The window's name is the lasting
 *  mark: the app rewrites the address while it boots, which drops the query. */
export function isHuddleWindow(search = window.location.search): boolean {
  return window.name.startsWith(WINDOW_NAME_PREFIX) || new URLSearchParams(search).get(WINDOW_PARAM) === 'huddle';
}

/** Opens the huddle in a window of its own, so the conversation stays usable
 *  beside it. One window per huddle: opening it again brings that window
 *  forward. Returns false when the browser blocked the window. */
export function openHuddleWindow(chatId: string): boolean {
  const opened = window.open(buildHuddleWindowLink(chatId), `${WINDOW_NAME_PREFIX}${chatId}`, 'popup,width=1180,height=760');
  if (!opened) return false;
  opened.focus();
  return true;
}
